import api from './api';

// 개인정보 동의서 조회
export const getConsents = async () => {
  const response = await api.get('/consent/');
  return response.data;
};

// 개인정보 동의서 동의
export const submitConsents = async (consents) => {
  const response = await api.post('/consent/submit/', { consents });
  return response.data;
};

